import { reactive } from 'vue'

export const mobileMenuStore = reactive({
  isOpened: false,
  toggle() {
    this.isOpened ? (this.isOpened = false) : (this.isOpened = true)
  },
  open() {
    this.isOpened = true
  },
  close() {
    this.isOpened = false
  },
})
